import apiUtil from './request'

export default {
    async login (data) {
        const result = await apiUtil.post(`/v1/api/manager/login`, data)
        return result
    },
    async queryAllCountryList (data) {
        const result = await apiUtil.get(`/v1/api/country/queryAllCountryList`, data)
        return result
    },
    async queryList (data) {
        const result = await apiUtil.post(`/v1/api/franchise/application/queryList`, data)
        return result
    },
    async queryReceiver () {
        const result = await apiUtil.get('/v1/api/intl/freight/receiver/queryReceiver')
        return result
    },
    async updateReceiver (data) {
        const result = await apiUtil.post('/v1/api/intl/freight/receiver/update', data)
        return result
    },
    async queryRate () {
        const result = await apiUtil.get('/v1/api/intl/freight/rate/queryRate')
        return result
    },
    async addRate (data) {
        const result = await apiUtil.post('/v1/api/intl/freight/rate/add', data)
        return result
    },
    async updateRate (data) {
        const result = await apiUtil.post('/v1/api/intl/freight/rate/update', data)
        return result
    },
    async delRateById (data) {
        const result = await apiUtil.post('/v1/api/intl/freight/rate/delete', data)
        return result
    },
    async queryRemark () {
        const result = await apiUtil.get('/v1/api/intl/freight/remark/queryRemark')
        return result
    },
    async insertOrUpdateRemark (data) {
        const result = await apiUtil.post('/v1/api/intl/freight/remark/update', data)
        return result
    },
    async updateSortById (data) {
        const result = await apiUtil.post('/v1/api/intl/freight/rate/updateSort', data)
        return result
    },
    async queryBlogList (data) {
        const result = await apiUtil.post('/v1/api/blog/queryBlogList', data)
        return result
    },
    async queryBlogDetailById (data) {
        const result = await apiUtil.get('/v1/api/blog/queryBlogDetail', data)
        return result
    },
    async updateBlog (data) {
        const result = await apiUtil.post('/v1/api/blog/update', data)
        return result
    },
    async queryBlogDetail (data) {
        const result = await apiUtil.get('/v1/api/blog/queryBackBlogDetail', data)
        return result
    },
    async updateBlog (data) {
        const result = await apiUtil.post('/v1/api/blog/update', data)
        return result
    },
    async createBlog (data) {
        const result = await apiUtil.post('/v1/api/blog/add', data)
        return result
    },
    async delBlog (data) {
        const result = await apiUtil.post('/v1/api/blog/delete', data)
        return result
    },
    async queryLocationPageList (data) {
        const result = await apiUtil.post('/v1/api/location/queryLocationPageList',data)
        return result
    },
    async createLocation (data) {
        const result = await apiUtil.post('/v1/api/location/add', data)
        return result
    },
    async delLocation (data) {
        const result = await apiUtil.post('/v1/api/location/delete', data)
        return result
    },
    async queryLocationById (data) {
        const result = await apiUtil.get('/v1/api/location/queryLocationById', data)
        return result
    },
    async updateLocation (data) {
        const result = await apiUtil.post('/v1/api/location/update', data)
        return result
    },
    // 问卷列表
    async getInformationSummaryListApi (data) {
        const result = await apiUtil.post('/v1/api/survey/querySurveyResultList', data)
        return result
    },
    // 图片回显
    async pictureShowApi(fileName) {
        const result = await apiUtil.getBlog(`/v1/api/file/view/${fileName}`);
        return result;
    },
    // 获取问卷导出key
    async getInformationSummaryExportKeyApi (data) {
        const result = await apiUtil.post('/v1/api/survey/exportSurveyKey', data)
        return result
    },
    // 导出问卷
    async exportInformationSummaryListApi (data) {
        const result = await apiUtil.getBlog('/v1/api/survey/exportSurvey', data)
        return result
    },
}



// WEBPACK FOOTER //
// ./src/api/cooperation.js